// extracted by mini-css-extract-plugin
export var wordContainer = "_qn-0";